import useSelectionTable from 'elements/Hooks/useSelectionTable'
import { get } from 'lodash'
import React from 'react'
import { EnquiriesApi } from '../../../api/Sales/Enquiries'
import Enquiries from '../../../components/Sales/Enquiries/Enquiries'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import useTitle from '../../../elements/Hooks/useTitle'

function EnquiriesCont() {
  useTitle('Enquiries')
  const { list, fetching, fetch } = useFetchList(EnquiriesApi.list)

  const {
    visible,
    modalType,
    object: enquiry,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
  } = useModalData(EnquiriesApi.create, EnquiriesApi.update, EnquiriesApi.remove, fetch)

  return (
    <Enquiries
      {...{
        list,
        fetching,
        submitting,
        visible,
        fetch,
        enquiry,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

export default EnquiriesCont
